/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { useSelector, useDispatch } from "react-redux";

import { updateFilters } from "../../slices/filtersSlice";
import types from "../../helpers/types";
import Select from "../common/Select";

import { useHistory } from "react-router-dom";

const RouteTypeFilter = () => {
  const routeType = useSelector((state) => {
    return state.filters.routeType;
  });
  const dispatch = useDispatch();
  const history = useHistory();

  const options = [
    { id: types.routeTypes.active, title: "Active" },
    { id: types.routeTypes.departure, title: "Departures" },
    { id: types.routeTypes.all, title: "All" },
  ];

  const handleChange = ({ target: { value } }) => {
    dispatch(updateFilters({ filters: { routeType: value }, history }));
  };

  return (
    <Select
      handleChange={handleChange}
      selectedValue={routeType}
      width={110}
      options={options}
      label="Route Type"
      inputId="route-type-filter"
      dataTestId="route-type-filter"
    />
  );
};

export default RouteTypeFilter;
